import { navigate } from 'gatsby';
import leadService from '../../../../../services/LeadService';
import { pushGTMWaitlistFailureEvent, pushGTMWaitlistSuccessEvent } from '../../../../../utils/gtm';

// We are in the "/booking-v2-lead" flow
export async function updateSalesforceWaitlistStatus(selectedLocation, successfulLink, failureLink) {
  try {
    const leadData = JSON.parse(sessionStorage.getItem('leadData')) || {};
    await leadService.updateWaitlistLeadStatus(leadData?.masterId, selectedLocation);

    pushGTMWaitlistSuccessEvent(selectedLocation?.code);
    navigate(successfulLink || '/');
  } catch (error) {
    pushGTMWaitlistFailureEvent(selectedLocation?.code);
    navigate(failureLink || '/');
  } finally {
    sessionStorage.removeItem('leadData');
  }
}
